import { motion } from "framer-motion";
import { MapPin, Navigation2, Clock, Phone, Train } from "lucide-react";
import { HOTEL } from "../data/site";

const highlights = [
  { icon: Train, label: "Bhadrak Railway Station", value: "approx. 3 km" },
  { icon: MapPin, label: "Bhadrak Bus Stand", value: "approx. 2 km" },
  { icon: Clock, label: "Check-in / Check-out", value: `${HOTEL.checkIn} / ${HOTEL.checkOut}` },
];

export default function Location() {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="section-padding bg-beige/40 dark:bg-card"
    >
      <div className="container-x">
        <div className="max-w-2xl">
          <span className="eyebrow">Find Us</span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl leading-tight text-foreground">
            Easy to reach,<br />
            <span className="italic text-[#7A1A24] dark:text-[#D4AF37]">comfortably close to everything.</span>
          </h2>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7 rounded-3xl overflow-hidden border border-border shadow-xl shadow-black/[0.04] dark:shadow-black/30"
          >
            <iframe
              title="Maa Durga Palace & Guest House location on Google Maps"
              src={HOTEL.mapsEmbed}
              className="w-full h-[420px] sm:h-[520px]"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="google-map-iframe"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: 0.15, duration: 0.7 }}
            className="lg:col-span-5 flex flex-col gap-5"
          >
            <div className="glass-card rounded-3xl p-7">
              <div className="flex items-start gap-3">
                <div className="h-11 w-11 rounded-xl bg-[#7A1A24]/10 dark:bg-[#D4AF37]/10 text-[#7A1A24] dark:text-[#D4AF37] grid place-items-center">
                  <MapPin size={20} />
                </div>
                <div>
                  <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground">
                    Address
                  </div>
                  <div className="mt-1.5 font-display text-xl text-foreground leading-snug">
                    {HOTEL.address.line1},<br />
                    {HOTEL.address.city}, {HOTEL.address.state} {HOTEL.address.pin}
                  </div>
                </div>
              </div>

              <div className="mt-6 flex flex-wrap gap-3">
                <a
                  href={HOTEL.mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="get-directions-btn"
                  className="btn-primary !py-3 !px-5 text-xs"
                >
                  <Navigation2 size={14} />
                  Get Directions
                </a>
                <a
                  href={`tel:${HOTEL.phoneE164}`}
                  data-testid="location-call-btn"
                  className="btn-gold !py-3 !px-5 text-xs"
                >
                  <Phone size={14} />
                  Call Now
                </a>
              </div>
            </div>

            <ul className="space-y-3">
              {highlights.map((h) => {
                const Icon = h.icon;
                return (
                  <li
                    key={h.label}
                    className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5"
                  >
                    <div className="h-10 w-10 rounded-lg bg-[#D4AF37]/15 text-[#A8862B] dark:text-[#E6C555] grid place-items-center">
                      <Icon size={18} />
                    </div>
                    <div className="flex-1">
                      <div className="text-sm font-medium text-foreground">{h.label}</div>
                      <div className="text-xs text-muted-foreground">{h.value}</div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
